export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-946.68d735e5.jpg";